/* =========================================================================
   Companion logic — PURE, unit-tested (mirrors dyk.ts / registerPrompt.ts).
   No DOM, no fetch, no storage. The controller and UI wire these decisions.
   ========================================================================= */

/** Correct-run pops fire once per game at runs of 3, 6, 9, … capped per game. */
export const CORRECT_POP_CAP = 4;

/** 5-minute throttle on the home greeting so re-entry from Arcade/history
    doesn't re-roll Theo's line every screen bounce; a local-date rollover
    always refreshes (new day = new greeting). */
export const GREETING_THROTTLE_MS = 5 * 60 * 1000;

/** Time-of-day bucket for the home greeting line (3 periods). */
export function greetingPeriod(hour: number): 'morning' | 'afternoon' | 'evening' {
  if (hour >= 5 && hour < 12) return 'morning';
  if (hour >= 12 && hour < 17) return 'afternoon';
  return 'evening';
}

/** True when an in-game correct run just crossed a multiple of 3 and the
    per-game pop cap has not been reached. */
export function correctPopShouldFire(correctRun: number, popsThisGame: number): boolean {
  return correctRun > 0 && correctRun % 3 === 0 && popsThisGame < CORRECT_POP_CAP;
}

/** True when the home greeting card should re-render its line: first render,
    a new local day, or once the throttle window has elapsed. */
export function greetingShouldRefresh(
  lastShownMs: number | null,
  lastDate: string | null,
  now: number,
  today: string,
): boolean {
  if (lastShownMs == null || lastDate == null) return true;
  if (today !== lastDate) return true;
  return now - lastShownMs >= GREETING_THROTTLE_MS;
}
